import React from "react";

const HeadingContainer = ({ data, center = false }) => {
  const { heading, info } = data;

  // Responsive heading styles
  const headingStyles = {
    fontFamily: 'Libre Franklin, sans-serif',
    fontSize: 'clamp(14px, 2.5vw, 18px)', // Responsive: 14px mobile → 18px desktop
    lineHeight: 'clamp(20px, 4vw, 36px)', // Responsive: 20px mobile → 36px desktop
    fontWeight: 800,
    margin: 0,
    marginBottom: '8px',
    color: 'var(--dark-text, #333)',
    textAlign: center ? 'center' : 'left',
  };

  // Responsive paragraph styles for center (paragraph1)
  const paragraph1Styles = {
    color: 'var(--dark-grey, #666)',
    fontFamily: 'Libre Franklin, sans-serif',
    fontSize: 'clamp(16px, 3vw, 20px)', // Smaller: 16px mobile → 20px desktop
    lineHeight: 'clamp(22px, 4vw, 28px)', // Smaller: 22px mobile → 28px desktop
    fontWeight: 300,
    margin: 0,
    textAlign: center ? 'center' : 'left',
  };

  // Responsive paragraph styles for left (paragraph2)
  const paragraph2Styles = {
    color: 'var(--dark-grey, #666)',
    fontFamily: 'Libre Franklin, sans-serif',
    fontSize: 'clamp(14px, 2.5vw, 16px)', // Smaller: 14px mobile → 16px desktop
    lineHeight: 'clamp(20px, 3.5vw, 24px)', // Smaller: 20px mobile → 24px desktop
    fontWeight: 300,
    margin: 0,
    textAlign: 'justify',
  };

  return (
    <div style={{ textAlign: center ? 'center' : 'left' }}>
      <h2 style={headingStyles}>
        {heading}
      </h2>
      {info && (
        <p style={center ? paragraph1Styles : paragraph2Styles}>
          {info}
        </p>
      )}
    </div>
  );
};

export default HeadingContainer;